import { Button, DataGrid } from '@cimplico/components';
import { Invitation } from '../../types/invitation';
import { formatDateTime, formatMixedCase } from '../../utilities/formatting';

type InvitationRowProps = {
    id: string;
    invitation: Invitation;
    disableActions: boolean;
    onDelete: (id: string) => void;
    onAccept: (invitation: Invitation) => void;
};

function InvitationRow({ id, invitation, disableActions, onDelete, onAccept }: InvitationRowProps): JSX.Element {
    return (
        <DataGrid.Row id={id} disabled>
            <p className="text-sm text-gray-700">{invitation.firm.name}</p>
            <p className="text-sm text-gray-700">{formatMixedCase(invitation.role)}</p>
            <p className="text-sm text-gray-700">{`${invitation.createdBy.firstName} ${invitation.createdBy.lastName}`}</p>
            <p className="text-sm text-gray-700">{formatDateTime(new Date(invitation.expires))}</p>
            <div className="flex items-center gap-4">
                <Button type="primary" size="sm" label="Accept" disabled={disableActions} onClick={(): void => onAccept(invitation)} />
                <Button
                    type="secondary"
                    size="sm"
                    label="Decline"
                    disabled={disableActions}
                    onClick={(): void => onDelete(invitation.id)}
                />
            </div>
        </DataGrid.Row>
    );
}
export default InvitationRow;
